"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ScrollInViewExtension_1 = require("../Plugin/WidgetExtension/ScrollInViewExtension");
/**
 * Core plugins.
 */
exports.plugins = [
    ScrollInViewExtension_1.ScrollInViewExtensionDefinition
];
